import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { IGetState, TCardId } from '../../../../../../../../types/types';
import { resetActiveComment } from '../effects/resetActiveComment';
import { toggleCommentsSort } from '../effects/toggleCommentsSort';

export const onToggleOrder = (
    cardId: TCardId,
): ThunkAction => {
    return (
        dispatch: Dispatch,
        getState: IGetState,
    ) => {
        dispatch(resetActiveComment(cardId));
        dispatch(toggleCommentsSort());
    };
};
